<template>
  <section class="content">
    <!-- Cabecera -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Proveedores</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
              <li class="breadcrumb-item active">Proveedores</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <div class="container-fluid">
      <!-- Switch de vista -->
      <div class="row mb-2">
        <div class="col-12 col-sm-6 col-md-4">
          <div id="btn-agregar-proveedor" class="info-box mb-3" @click="nuevoProveedor()" data-target="#proveedorModal" data-toggle="modal">
            <a href="javascript:void(0)" class="btn btn-block info-box-icon bg-info elevation-1"><i class="fas fa-plus"></i></a>
            <div class="info-box-content">
              <span class="info-box-text">Proveedor</span>
              <span class="info-box-number">Agregar</span>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <div id="btn-pdf-proveedores" class="info-box mb-3" @click="descargarPDF()">
            <a href="javascript:void(0)" class="info-box-icon bg-danger elevation-1"><i class="fas fa-file-pdf"></i></a>
            <div class="info-box-content">
              <span class="info-box-text">Reporte</span>
              <span class="info-box-number">Descargar PDF</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">

            <!-- Header del card -->
            <div class="card-header">
              <h3 class="card-title">
                Lista de proveedores que puedes administrar
              </h3>
            </div>

            <!-- Body: Tabla o Cards -->
            <div class="card-body">

              <!-- VISTA TABLA -->
                <table id="tablaProveedor" class="table table-bordered table-striped w-100">
                  <thead>
                    <tr>
                      <th>Código</th>
                      <th>Descripción</th>
                      <th>Empresa</th>
                      <th>Estatus</th>
                      <th>Opciones</th>
                    </tr>
                  </thead>
                </table>

              <!-- Modal / Formulario -->
              <formProveedor :empresas="empresas" :proveedor="proveedorActual" @success="obtenerProveedores" />
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { ref, onMounted, onBeforeUnmount, nextTick } from "vue";
import api from "@/services/api";
import { tutorial } from "@/plugins/tutorial";
import { loading } from '@/plugins/loading.js';
import { alert } from '@/plugins/alert.js';
import FormProveedor from "@/components/FormProveedor.vue";

export default {
  components: { FormProveedor },

  setup() {
    const dt = ref(null);
    const Proveedores = ref([]);
    const empresas = ref([]);
    const proveedorActual = ref(null);
    const viewMode = ref("table");

    async function obtenerEmpresas() {
      try {
        const response = await api.get("/empresa");
        empresas.value = response.data;
      } catch (error) {
        console.error("Error al obtener empresas:", error);
      }
    }

    async function obtenerProveedores() {
      try {
        const response = await api.get("/proveedor");
        Proveedores.value = response.data;

        await nextTick();

        if (!dt.value && window.$ && $.fn.DataTable) {
          dt.value = $(`#tablaProveedor`).DataTable({
            data: Proveedores.value,
            columns: [
              { data: "codigo",      title: "Código" },
              { data: "descripcion", title: "Descripción" },
              {
                data: "empresa.nombre",
                title: "Empresa",
                defaultContent: ""
              },
              {
                data: "estatus",
                title: "Estatus",
                render: data => {
                  const badgeClass = data ? 'badge-success' : 'badge-danger';
                  const text = data ? 'ACTIVO' : 'INACTIVO';
                  return `<span class="badge ${badgeClass}">${text}</span>`;
                },
                className: "text-center"
              },
              {
                data: null,
                title: "Opciones",
                orderable: false,
                className: "text-center",
                render: row => `
                  <button
                    class="btn btn-warning btn-sm editar"
                    data-id="${row.id}"
                  >
                    <i class="fas fa-pen-to-square"></i>
                  </button>
                  <button
                    class="btn btn-danger btn-sm eliminar"
                    data-id="${row.id}"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                `
              }
            ],
            responsive: true,
            autoWidth: false,
            pageLength: 10,
            lengthChange: false,
            pagingType: 'numbers',
            language: {
              url: 'https://cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json'
            },
            dom: // 1ª fila: filtro (f) ocupa toda la anchura en móvil y la mitad en md+
              '<"row mb-3"<"col-12 col-md-6"f>>' +
              // tabla
              't' +

              // fila 1: info centrado
              '<"row mt-3"<"col-12 text-center"i>>' +
              // fila 2: paginación centrada
              '<"row"<"col-12 d-flex justify-content-center"p>>',
          });

          const table = dt.value;
          $("#tablaProveedor tbody")
            .on("click", "button.editar", async e => {
              const row = $(e.currentTarget).closest("tr");
              const data = table.row(row).data();
              editarProveedor(data);
            })
            .on("click", "button.eliminar", async e => {
              const data = table
                .row($(e.currentTarget).closest("tr"))
                .data();
              await eliminarProveedor(data);
            });
        } else if (dt.value) {
          dt.value.clear().rows.add(Proveedores.value).draw();
        }
      } catch (error) {
        console.error("Error al obtener proveedores:", error);
      } finally {
        loading.hide();
      }
    }

    async function eliminarProveedor(proveedor) {
      const result = await alert.show({
        title: '¿Estás seguro?',
        text: `Vas a eliminar al proveedor: ${proveedor.descripcion}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        loading.show('Eliminando proveedor...');
        try {
          await api.delete(`/proveedor/${proveedor.id}`);
          // Pequeña pausa para que el usuario perciba el estado de carga
          await new Promise(resolve => setTimeout(resolve, 1000));
          Proveedores.value = Proveedores.value.filter(x => x.id !== proveedor.id);
          dt.value.clear().rows.add(Proveedores.value).draw();
          loading.hide();
          alert.toast({ title: 'Proveedor eliminado correctamente', icon: 'success', timer: 3000 });
        } catch (error) {
          loading.hide();
          alert.toast({ title: 'Error al eliminar el proveedor', icon: 'error', text: error.response.data.message, timer: 3000 });
        }
      }
    }

    function nuevoProveedor() {
      proveedorActual.value = null;
      nextTick(() => $("#proveedorModal").modal("show"));
    }

    function editarProveedor(proveedor) {
      proveedorActual.value = proveedor;
      nextTick(() => $("#proveedorModal").modal("show"));
    }

    async function descargarPDF() {
      try {
        const response = await api.get("/pdf/proveedores", { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'proveedores.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        alert.toast({ icon: 'error', title: 'Error al generar PDF' });
      }
    }

    function iniciarTutorial() {
      const steps = [
        {
          element: '#btn-agregar-proveedor',
          title: 'Nuevo Proveedor',
          text: 'Haz clic en este recuadro para registrar un nuevo proveedor en el sistema.',
          position: 'bottom'
        },
        {
          element: '#btn-pdf-proveedores',
          title: 'Descargar Reporte',
          text: 'Haz clic aquí para generar y descargar un listado de todos los proveedores en formato PDF.',
          position: 'bottom'
        },
        {
          element: '.card-body',
          title: 'Listado de Proveedores',
          text: 'Aquí verás la lista de proveedores registrados. Puedes usar el buscador para filtrar.',
          position: 'top'
        }
      ];

      const table = $('#tablaProveedor');
      const isCollapsed = table.hasClass('collapsed');
      // Verificamos si la columna de acciones (última) está visible
      const actionsVisible = table.find('tbody tr:first-child td:last-child').is(':visible');

      if (isCollapsed && !actionsVisible) {
        const firstRow = table.find('tbody tr:first-child');

        // Si la fila ya está expandida, la colapsamos para que el usuario realice la acción
        if (firstRow.hasClass('parent')) {
          const control = firstRow.find('.dtr-control');
          if (control.length) control.click();
          else firstRow.find('td:first-child').click();
        }

        // Modo responsivo con acciones ocultas
        steps.push({
          element: '#tablaProveedor tbody tr:first-child td:first-child',
          title: 'Ver Detalles',
          text: 'En pantallas pequeñas, haz clic en el símbolo (+) o en la primera columna para ver los datos ocultos y las acciones.',
          position: 'bottom',
          tooltipClass: 'hide-next-btn'
        });

        // Listener para habilitar/deshabilitar el botón Siguiente al expandir/colapsar la fila
        firstRow.off('click.tutorial');
        firstRow.on('click.tutorial', function() {
          setTimeout(() => {
            const tooltip = document.querySelector('.introjs-tooltip');
            if (!tooltip) return;

            // La clase 'parent' de DataTables indica que la fila está expandida
            if ($(this).hasClass('parent')) {
              tooltip.classList.remove('hide-next-btn'); // Muestra el botón
            } else {
              tooltip.classList.add('hide-next-btn'); // Oculta el botón
            }
          }, 200); // Pequeño delay para esperar la animación de DataTables
        });

        steps.push({
          element: '.dtr-details .editar', // Botón dentro del detalle expandido
          title: 'Editar Proveedor',
          text: 'Haz clic en el botón amarillo para modificar los datos de un proveedor existente.',
          position: 'left'
        });

        steps.push({
          element: '.dtr-details .eliminar',
          title: 'Eliminar Proveedor',
          text: 'Haz clic en el botón rojo para eliminar un proveedor. Esta acción te pedirá confirmación.',
          position: 'left'
        });
      } else {
        // Modo normal o acciones visibles
        steps.push({
          element: '.editar',
          title: 'Editar Proveedor',
          text: 'Haz clic en el botón amarillo para modificar los datos de un proveedor existente.',
          position: 'left'
        });

        steps.push({
          element: '.eliminar',
          title: 'Eliminar Proveedor',
          text: 'Haz clic en el botón rojo para eliminar un proveedor. Esta acción te pedirá confirmación.',
          position: 'left'
        });
      }

      tutorial.start(steps);
    }

    onMounted(() => {
      obtenerProveedores();
      obtenerEmpresas();
      tutorial.set(iniciarTutorial);
    });
    onBeforeUnmount(() => {
      tutorial.set(null);
      if (dt.value) {
        dt.value.destroy();
        dt.value = null;
      }
    });

    return { viewMode, Proveedores, proveedorActual, nuevoProveedor, editarProveedor, obtenerProveedores, eliminarProveedor, obtenerEmpresas, empresas, descargarPDF };
  }
};
</script>
<style>
.hide-next-btn .introjs-nextbutton,
.hide-next-btn .introjs-nextBtn {
  display: none !important;
}
</style>